import { isUndefined } from 'lodash';
import config from '../../../config/apiKeys.json';

const ENV_ALIASES_BY_HOSTNAME_MAP = {
    [config.dev_host]: 'development',
    [config.stage_host]: 'staging',
    [config.prod_host]: 'production',
    [config.local_host]: 'local',
};

const CURRENT_HOSTNAME = window.location.hostname.toLowerCase();

export const isHotjarInited = () => isUndefined(window.isHotjarInited) ? false : window.isHotjarInited;

export const checkUserHasTalenyaEmail = user => user && user.email && user.email.endsWith('talenya.com');

export const isAutomation = (user = {}) => {
    try {
        const email = user.$email;
        const [name] = email.split('@');

        return name.indexOf('automation') !== -1;
    } catch (err) {
        return false;
    }
};

export const getMappedOptions = (options, mapCollection) => {
    if (!options) {
        return {};
    }

    const mappedOptions = {};

    for (const key in options) {
        if (key in options) {
            const trackingParamName = mapCollection[key];
            if (trackingParamName) {
                mappedOptions[trackingParamName] = options[key];
            }
        }
    }

    return mappedOptions;
};

export const getCurrentEnv = () => ENV_ALIASES_BY_HOSTNAME_MAP[CURRENT_HOSTNAME];

export const USER_OPTIONS_MAP = {
    _id: '_id',
    userLoginType: 'user_login',
    recruiterId: 'recruiter_id',
    employerRepId: 'employer_rep_id',
    created: 'created',
    employerId: 'employer_id',
    employerName: 'employer_name',
    roleType: 'role_type',
    fullName: 'full_name',
    office: 'employer_sales_status',
    user_id: 'user_id',
    loginType: 'user_login',
    isTalenyaUser: 'is_talenya_user',
    created_at: 'created_at',
    updated_at: 'updated_at',
    name: '$name',
    email: '$email',
};

export const HOTJAR_TAGS = {};
